const RESERVED_PATH_SEGMENTS = new Set([
  'suggested-orders',
  'smart-settings',
  'settings',
  'suggestions',
]);

const QUERY_KEYS = ['token', 'customerNumber', 'customer', 'accountNumber'];

export const resolveCustomerToken = () => {
  if (window.location.hostname === 'localhost') {
    return 'kgjR-795-XFELo-0wv2S-Cc3-yyI-LcnL-8hAJ-h2Vi8-8or2I-QgAm-Rc2-3GoX-nN8X-l1i-GKyi2-MVkrs-XpDu2-7GNk-YED';
  }

  const queryParams = new URLSearchParams(window.location.search);
  for (const key of QUERY_KEYS) {
    const value = queryParams.get(key);
    if (value) {
      return value;
    }
  }

  const pathSegments = window.location.pathname.split('/').filter(Boolean);
  const lastSegment = pathSegments[pathSegments.length - 1];
  if (lastSegment && !RESERVED_PATH_SEGMENTS.has(lastSegment)) {
    return decodeURIComponent(lastSegment);
  }

  return process.env.REACT_APP_SMART_ORDERS_TOKEN || localStorage.getItem('smartOrdersToken') || '';
};
